import React, { useEffect, useState, useContext, useRef, useMemo } from 'react';
import HeaderSection from "../banner/HeaderSection";
import { toast } from "react-toastify";
import axios from 'axios';
import * as CONST from "../../../component/config/Constant";
import { AuthContext } from '../../../component/context/AuthContext';
import Loading from "react-fullscreen-loading";
import "../../../assets/css/helpdesk.css";
import "../../../assets/css/dashboard.css";
import moment from 'moment';
import Parser from 'html-react-parser';
import DivSpinner from "../../../component/utilities/Spinner";
import { FiSend, FiSearch, FiAlertCircle, FiClock, FiCheckCircle, FiXCircle, FiMinusCircle } from "react-icons/fi";
import { StatusBadge, PriorityBadge, PriorityPills } from "../../../component/utilities/Badges";
import Select from 'react-select';

function ManageTickets({ myOnly = false }) {
  const [authUserData] = useContext(AuthContext);
  const [fullLoading, setFullLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  // Ticket list
  const [tickets, setTickets] = useState([]);
  const [allTickets, setAllTickets] = useState([]);
  const [activeTicket, setActiveTicket] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filterStatus, setFilterStatus] = useState('');

  // Search filters
  const [activePage, setActivePage] = useState(1);
  const [date, setDate] = useState('');
  const [username, setUserName] = useState('');
  const [departmentName, setDepartmentName] = useState('');
  const [filterticketid, setFilterTicketId] = useState('');
  const [departmentList, setdepartmentList] = useState([]);

  // Comments
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [commentsLoading, setCommentsLoading] = useState(false);

  // Employee asset history
  const [empAssetHistory, setEmpAssetHistory] = useState([]);
  const [centerTab, setCenterTab] = useState('conversation');
  const [rejectReason, setRejectReason] = useState('');
  const [approving, setApproving] = useState(false);

  // Asset allocation
  const [availableAssets, setAvailableAssets] = useState([]);
  const [selectedAssetItemId, setSelectedAssetItemId] = useState('');
  const [allocating, setAllocating] = useState(false);

  // Status update
  const [updatingStatus, setUpdatingStatus] = useState(false);

  let user_id = '';
  let isToken = '';
  let eHeadId = '';
  let is_admin = 0;
  if (authUserData && authUserData[0]) {
    isToken = authUserData[0].token || "";
    user_id = authUserData[0].user_id || "";
    eHeadId = authUserData[0].is_head || "";
    is_admin = authUserData[0].is_admin || 0;
  }

  useEffect(() => {
    getDepartmentList();
    getTicketList();
  }, []);

  async function getTicketList() {
    setLoading(true);
    try {
      const response = await axios.post(CONST.GET_TICKET_LIST, {
        user_id, sort: { order_by: "id", order: "desc" },
        page_number: 1, limit: 10000, is_head: eHeadId,
        srchDate: date ? date : '',
        username: username,
        departmentName: departmentName,
        ticketId: filterticketid,
        owner_only: myOnly ? 1 : 0
      }, { headers: { Authorization: `Basic ${isToken}` } });

      if (response.data.status === "success") {
        const data = response.data.data || [];
        setAllTickets(data);
        applyFilters(searchQuery, filterStatus, data);
      } else {
        setAllTickets([]);
        setTickets([]);
      }
    } catch (e) {}
    setLoading(false);
  }

  async function getDepartmentList() {
    try {
      const response = await axios.post(CONST.GET_ACTIVE_DEPARTMENT_LIST, {
        headers: { Authorization: `Basic ${isToken}` },
      });
      if (response.data.status === "success") {
        setdepartmentList(response.data.data || []);
      }
    } catch (e) {}
  }

  const fetchComments = async (ticketId) => {
    setCommentsLoading(true);
    try {
      const response = await axios.post(CONST.GET_COMMENT, {
        fk_ticket_id: ticketId
      }, { headers: { Authorization: `Bearer ${isToken}` } });
      if (response.data.status === 'success') {
        setComments(response.data.data || []);
      } else {
        setComments([]);
      }
    } catch (e) {}
    setCommentsLoading(false);
  };

  // ===== ACTIONS =====
  const handleTicketClick = (ticket) => {
    setActiveTicket(ticket);
    fetchComments(ticket.id);
    setEmpAssetHistory([]);
    setCenterTab('conversation');
    // Fetch employee's asset history for hardware requests
    if (ticket.category === 'hardware_request' && ticket.createdByData) {
      fetchEmpAssetHistory(ticket.createdByData.id);
    }
    // Fetch available assets if head approved
    if (ticket.category === 'hardware_request' && ticket.status === '5' && ticket.asset_type_id) {
      fetchAvailableAssets(ticket.asset_type_id);
    }
  };

  const handleHeadApprove = async (action) => {
    if (action === 'reject' && !rejectReason.trim()) {
      toast.error("Please provide a reason for rejection.");
      return;
    }
    setApproving(true);
    try {
      const res = await axios.post(CONST.HEAD_APPROVE_REQUEST, {
        request_id: activeTicket.id,
        action: action,
        reason: rejectReason,
        user_id: user_id,
      }, { headers: { Authorization: `Bearer ${isToken}` } });
      if (res.data.status === 'success') {
        toast.success(res.data.message);
        setRejectReason('');
        getTicketList();
        // Update active ticket status locally
        setActiveTicket({ ...activeTicket, status: action === 'approve' ? '5' : '3' });
        fetchComments(activeTicket.id);
      } else {
        toast.error(res.data.message);
      }
    } catch (e) {
      toast.error("Something went wrong.");
    }
    setApproving(false);
  };

  const fetchAvailableAssets = async (assetTypeId) => {
    if (!assetTypeId) return;
    try {
      const res = await axios.get(CONST.GET_AVAILABLE_ASSETS + assetTypeId, {
        headers: { Authorization: `Bearer ${isToken}` }
      });
      if (res.data.status === 'success') setAvailableAssets(res.data.data || []);
    } catch (e) { setAvailableAssets([]); }
  };

  const handleAllocateAsset = async () => {
    if (!selectedAssetItemId) { toast.error("Please select an asset to allocate."); return; }
    setAllocating(true);
    try {
      const res = await axios.post(CONST.ALLOCATE_ASSET_TO_REQUEST, {
        request_id: activeTicket.id,
        asset_item_id: selectedAssetItemId,
        user_id: user_id,
      }, { headers: { Authorization: `Bearer ${isToken}` } });
      if (res.data.status === 'success') {
        toast.success(res.data.message);
        setSelectedAssetItemId('');
        setAvailableAssets([]);
        setActiveTicket({ ...activeTicket, status: '2' });
        getTicketList();
        fetchComments(activeTicket.id);
      } else {
        toast.error(res.data.message);
      }
    } catch (e) { toast.error("Something went wrong."); }
    setAllocating(false);
  };

  const fetchEmpAssetHistory = async (empId) => {
    try {
      const res = await axios.post(CONST.MY_ASSET_ITEMS, { user_id: empId }, { headers: { Authorization: `Bearer ${isToken}` } });
      const data = res.data.status === 'success' ? (res.data.data || []).map(a => ({
        name: a.assetType?.name || '-', brand: a.brand?.name || '-',
        status: 'Allocated', statusColor: '#059669',
        date: a.updated_at, tag: a.asset_tag
      })) : [];
      setEmpAssetHistory(data);
    } catch (e) {}
  };

  const handleSendComment = async () => {
    if (!newComment.trim() || !activeTicket) return;
    try {
      await axios.post(CONST.ADD_COMMENT, {
        fk_ticket_id: activeTicket.id,
        comment_added_by: user_id,
        comment: newComment
      }, { headers: { Authorization: `Basic ${isToken}`, 'Content-Type': 'application/json' } });
      setNewComment('');
      fetchComments(activeTicket.id);
    } catch (e) {
      toast.error("Failed to send comment.");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendComment();
    }
  };

  const handleStatusChange = async (newStatus) => {
    if (!activeTicket) return;
    setUpdatingStatus(true);
    try {
      await axios.post(CONST.UPDATE_STATUS_TICKET, {
        ticket_id: activeTicket.id, status: newStatus
      }, { headers: { Authorization: `Basic ${isToken}` } });
      toast.success("Status updated.");
      setActiveTicket({ ...activeTicket, status: newStatus });
      getTicketList();
    } catch (e) {
      toast.error("Failed to update status.");
    }
    setUpdatingStatus(false);
  };

  const applyFilters = (query, status, sourceData) => {
    let filtered = sourceData || allTickets;
    if (status) filtered = filtered.filter(t => t.status === status);
    if (query) {
      const q = query.toLowerCase();
      filtered = filtered.filter(t =>
        (t.title && t.title.toLowerCase().includes(q)) ||
        (t.createdByData && (t.createdByData.first_name + ' ' + t.createdByData.last_name).toLowerCase().includes(q)) ||
        (t.id && t.id.toString().includes(q))
      );
    }
    setTickets(filtered);
  };

  const handleSearch = (val) => {
    setSearchQuery(val);
    applyFilters(val, filterStatus);
  };

  const handleStatClick = (status) => {
    const val = filterStatus === status ? '' : status;
    setFilterStatus(val);
    applyFilters(searchQuery, val);
  };

  // ===== HELPERS =====
  const getStatusStyle = (status) => {
    const map = {
      "0": { bg: "#dbeafe", color: "#1e40af", label: "Open" },
      "7": { bg: "#e0e7ff", color: "#3730a3", label: "Accepted" },
      "8": { bg: "#fffbeb", color: "#d97706", label: "Pending Approval" },
      "5": { bg: "#f3e8ff", color: "#7c3aed", label: "Approved" },
      "1": { bg: "#fff3cd", color: "#856404", label: "In Progress" },
      "2": { bg: "#d1fae5", color: "#065f46", label: "Allocated" },
      "9": { bg: "#d4edda", color: "#155724", label: "Resolved" },
      "3": { bg: "#fee2e2", color: "#dc2626", label: "Rejected" },
      "4": { bg: "#e2e8f0", color: "#475569", label: "Closed" },
      "6": { bg: "#f1f5f9", color: "#64748b", label: "Returned" },
    };
    return map[status] || { bg: "#f1f5f9", color: "#64748b", label: "Unknown" };
  };

  const getPriorityStyle = (p) => {
    if (p === 'urgent') return { bg: "#fef2f2", color: "#991b1b" };
    if (p === 'high') return { bg: "#fee2e2", color: "#dc2626" };
    if (p === 'medium') return { bg: "#fef3c7", color: "#b45309" };
    return { bg: "#ecfdf5", color: "#059669" };
  };

  const timeAgo = (date) => {
    const m = moment(date);
    const diff = moment().diff(m, 'hours');
    if (diff < 1) return moment().diff(m, 'minutes') + 'm ago';
    if (diff < 24) return diff + 'h ago';
    if (diff < 48) return 'Yesterday';
    return m.format('DD-MM-YYYY');
  };

  const statCards = [
    { status: "0", label: "Open", icon: <FiAlertCircle size={18} />, bg: "#dbeafe", color: "#1e40af" },
    { status: "7", label: "Accepted", icon: <FiCheckCircle size={18} />, bg: "#e0e7ff", color: "#3730a3" },
    { status: "8", label: "Pending Approval", icon: <FiClock size={18} />, bg: "#fffbeb", color: "#d97706" },
    { status: "5", label: "Approved", icon: <FiCheckCircle size={18} />, bg: "#f3e8ff", color: "#7c3aed" },
    { status: "1", label: "In Progress", icon: <FiClock size={18} />, bg: "#fef3c7", color: "#b45309" },
    { status: "9", label: "Resolved", icon: <FiCheckCircle size={18} />, bg: "#d4edda", color: "#155724" },
    { status: "3", label: "Rejected", icon: <FiXCircle size={18} />, bg: "#fee2e2", color: "#dc2626" },
    { status: "4", label: "Closed", icon: <FiMinusCircle size={18} />, bg: "#f1f5f9", color: "#475569" },
  ];

  return (
    <>
      <Loading loading={fullLoading} background="rgba(0,0,0,0.5)" loaderColor="#fff" />
      <HeaderSection title={myOnly ? "My" : "Manage"} heading="Requests" />

      {/* Stats Cards — clickable */}
      <div className="container-xl mt-3">
        <div className="row db-stats-row">
          {statCards.map((s) => (
            <div className="col-6 col-md-2 mb-2" key={s.status}>
              <div
                className={`db-stat-card ${filterStatus === s.status ? "border-primary" : ""}`}
                style={{ cursor: "pointer", borderWidth: filterStatus === s.status ? "2px" : "1px" }}
                onClick={() => handleStatClick(s.status)}
              >
                <div className="db-stat-icon" style={{ background: s.bg, color: s.color }}>{s.icon}</div>
                <div className="db-stat-value">{allTickets.filter(t => t.status === s.status).length}</div>
                <div className="db-stat-label">{s.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Search Filters */}
      <div className="container-xl mt-3">
        <div className="card">
          <div className="card-body border-bottom py-3">
            <div className="row">
              <div className="col-md-2">
                <div className="form-group mb-2">
                  <label className="form-label">Employee Name</label>
                  <input type="text" className="form-control" placeholder="Search..." value={username} onChange={(e) => setUserName(e.target.value)} />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group mb-2">
                  <label className="form-label">Department</label>
                  <select className="form-select form-control" value={departmentName} onChange={(e) => setDepartmentName(e.target.value)}>
                    <option value="">All</option>
                    {departmentList && departmentList.map((d) => (
                      <option key={d.id} value={d.id}>{d.name}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group mb-2">
                  <label className="form-label">Request #</label>
                  <input type="number" className="form-control" placeholder="#..." value={filterticketid} onChange={(e) => setFilterTicketId(e.target.value)} />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group mb-2">
                  <label className="form-label">Status</label>
                  <select className="form-select form-control" value={filterStatus} onChange={(e) => { setFilterStatus(e.target.value); applyFilters(searchQuery, e.target.value); }}>
                    <option value="">All</option>
                    <option value="0">Open</option>
                    <option value="7">Accepted</option>
                    <option value="8">Pending Approval</option>
                    <option value="5">Approved</option>
                    <option value="1">In Progress</option>
                    <option value="2">Allocated</option>
                    <option value="9">Resolved</option>
                    <option value="3">Rejected</option>
                    <option value="4">Closed</option>
                    <option value="6">Returned</option>
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group mb-2">
                  <label className="form-label">&nbsp;</label>
                  <div>
                    <button className="btn btn-blue d-none d-sm-inline-block mr-3" onClick={() => { setActivePage(1); getTicketList(); }}>
                      <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-search" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><circle cx="10" cy="10" r="7"></circle><line x1="21" y1="21" x2="15" y2="15"></line></svg>
                      Search
                    </button>
                    &nbsp;
                    <button className="btn btn-outline-primary mr-3" onClick={() => { setDate(''); setDepartmentName(''); setFilterTicketId(''); setUserName(''); setFilterStatus(''); setSearchQuery(''); setActivePage(1); getTicketList(); }}>
                      <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-x" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 3-Panel Layout */}
      <div className="container-xl mt-3 mb-4">
        <div className="helpdesk-wrapper">

          {/* LEFT — Ticket List */}
          <div className="helpdesk-list">
            <div className="helpdesk-list-header">
              <h6>All Requests ({allTickets.length})</h6>
              <div className="helpdesk-list-search">
                <FiSearch />
                <input
                  type="text"
                  placeholder="Search by name, ID..."
                  value={searchQuery}
                  onChange={(e) => handleSearch(e.target.value)}
                />
              </div>
            </div>
            <div className="helpdesk-list-body">
              {loading ? <div className="p-3"><DivSpinner size="sm" color="primary" /></div> :
                tickets.length === 0 ? <div className="p-3 text-center text-muted" style={{ fontSize: "0.82rem" }}>No requests found</div> :
                tickets.map((t) => {
                  const ss = getStatusStyle(t.status);
                  const ps = getPriorityStyle(t.priority);
                  return (
                    <div
                      key={t.id}
                      className={`helpdesk-ticket-item ${activeTicket && activeTicket.id === t.id ? 'active' : ''}`}
                      onClick={() => handleTicketClick(t)}
                    >
                      <div className="ticket-top">
                        <span className="ticket-id">#REQ-{String(t.id).padStart(3, '0')}</span>
                        <span className="ticket-time">{timeAgo(t.created_at)}</span>
                      </div>
                      <div className="ticket-name">
                        {t.createdByData ? t.createdByData.first_name + ' ' + t.createdByData.last_name : 'Unknown'}
                      </div>
                      <div className="ticket-subject">{t.title}</div>
                      <div className="ticket-meta">
                        <StatusBadge status={ss.label} />
                        {t.priority && <PriorityBadge priority={t.priority} />}
                        {t.category && t.category !== 'general' && (
                          <span style={{ background: t.category === 'hardware_request' ? '#dbeafe' : t.category === 'software_request' ? '#f3e8ff' : t.category === 'it_support' ? '#ffedd5' : '#dcfce7', color: t.category === 'hardware_request' ? '#1e40af' : t.category === 'software_request' ? '#7c3aed' : t.category === 'it_support' ? '#c2410c' : '#166534', padding: '1px 8px', borderRadius: 12, fontSize: '0.68rem', fontWeight: 600 }}>
                            {t.category === 'hardware_request' ? 'Hardware' : t.category === 'software_request' ? 'Software' : t.category === 'it_support' ? 'IT Support' : t.category === 'access_request' ? 'Access' : t.category}
                          </span>
                        )}
                      </div>
                    </div>
                  );
                })
              }
            </div>
          </div>

          {/* CENTER — Conversation */}
          <div className="helpdesk-chat">
            {activeTicket ? (
              <>
                <div className="helpdesk-chat-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <span className="chat-ticket-id">#REQ-{String(activeTicket.id).padStart(3, '0')}</span>
                    <span className="chat-ticket-title">{activeTicket.title}</span>
                  </div>
                  {(
                  <div style={{ display: 'flex', gap: '4px' }}>
                    <button
                      style={{ padding: '4px 12px', fontSize: '0.75rem', fontWeight: 600, borderRadius: 6, border: centerTab === 'conversation' ? '2px solid #1167e8' : '1px solid #e2e8f0', background: centerTab === 'conversation' ? '#f0f5ff' : '#fff', color: centerTab === 'conversation' ? '#1167e8' : '#64748b', cursor: 'pointer' }}
                      onClick={() => setCenterTab('conversation')}
                    >Conversation</button>
                    <button
                      style={{ padding: '4px 12px', fontSize: '0.75rem', fontWeight: 600, borderRadius: 6, border: centerTab === 'history' ? '2px solid #1167e8' : '1px solid #e2e8f0', background: centerTab === 'history' ? '#f0f5ff' : '#fff', color: centerTab === 'history' ? '#1167e8' : '#64748b', cursor: 'pointer' }}
                      onClick={() => setCenterTab('history')}
                    >History ({empAssetHistory.length})</button>
                    {(eHeadId == '1' || is_admin == '1') && (
                    <button
                      className={activeTicket.status === '8' && centerTab !== 'approval' ? 'approval-tab-pending' : ''}
                      style={{ padding: '4px 12px', fontSize: '0.75rem', fontWeight: 600, borderRadius: 6, border: centerTab === 'approval' ? '2px solid #059669' : '1px solid #e2e8f0', background: centerTab === 'approval' ? '#ecfdf5' : '#fff', color: centerTab === 'approval' ? '#059669' : '#64748b', cursor: 'pointer' }}
                      onClick={() => setCenterTab('approval')}
                    >Approval</button>
                    )}
                  </div>
                  )}
                </div>

                {centerTab === 'approval' ? (
                <div className="helpdesk-chat-body" style={{ padding: '24px' }}>
                  <h6 style={{ fontSize: '0.9rem', fontWeight: 700, marginBottom: 16 }}>Head Approval</h6>

                  {activeTicket.status === '8' ? (
                    <>
                      <div style={{ background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: 8, padding: '12px 16px', marginBottom: 16, fontSize: '0.82rem' }}>
                        <strong>Pending Approval</strong> - This request needs department head approval.
                      </div>

                      <div style={{ marginBottom: 16 }}>
                        <label className="form-label fw-bold" style={{ fontSize: '0.82rem' }}>Request Summary</label>
                        <table className="table table-sm table-bordered" style={{ fontSize: '0.8rem' }}>
                          <tbody>
                            <tr><td style={{ fontWeight: 600, width: '35%' }}>Requested By</td><td>{activeTicket.createdByData ? activeTicket.createdByData.first_name + ' ' + activeTicket.createdByData.last_name : '-'}</td></tr>
                            <tr><td style={{ fontWeight: 600 }}>Asset Type</td><td>{activeTicket.assetType?.name || '-'}</td></tr>
                            <tr><td style={{ fontWeight: 600 }}>Quantity</td><td>{activeTicket.quantity || 1}</td></tr>
                            <tr><td style={{ fontWeight: 600 }}>Justification</td><td>{activeTicket.justification || '-'}</td></tr>
                            <tr><td style={{ fontWeight: 600 }}>Subject</td><td>{activeTicket.title}</td></tr>
                          </tbody>
                        </table>
                      </div>

                      <div style={{ marginBottom: 12 }}>
                        <label className="form-label" style={{ fontSize: '0.82rem' }}>Rejection Reason (required to reject)</label>
                        <textarea
                          className="form-control"
                          rows="2"
                          placeholder="Enter reason if rejecting..."
                          value={rejectReason}
                          onChange={(e) => setRejectReason(e.target.value)}
                          style={{ fontSize: '0.82rem' }}
                        />
                      </div>

                      <div style={{ display: 'flex', gap: '10px' }}>
                        <button className="btn btn-success" onClick={() => handleHeadApprove('approve')} disabled={approving} style={{ fontSize: '0.82rem' }}>
                          {approving ? 'Processing...' : 'Approve Request'}
                        </button>
                        <button className="btn btn-danger" onClick={() => handleHeadApprove('reject')} disabled={approving || !rejectReason.trim()} style={{ fontSize: '0.82rem' }}>
                          {approving ? 'Processing...' : 'Reject Request'}
                        </button>
                      </div>
                    </>
                  ) : activeTicket.status === '5' ? (
                    <>
                      <div style={{ background: '#ecfdf5', border: '1px solid #6ee7b7', borderRadius: 8, padding: '12px 16px', marginBottom: 16, fontSize: '0.85rem' }}>
                        <strong style={{ color: '#059669' }}>Head Approved</strong> - Select an available asset to allocate to the employee.
                        {activeTicket.head_approved_date && (
                          <div style={{ marginTop: 4, color: '#64748b', fontSize: '0.78rem' }}>
                            Approved on {moment(activeTicket.head_approved_date).format('DD MMM YYYY, h:mm a')}
                          </div>
                        )}
                      </div>

                      <div style={{ marginBottom: 16 }}>
                        <label className="form-label fw-bold" style={{ fontSize: '0.82rem' }}>Select Asset to Allocate</label>
                        {availableAssets.length === 0 ? (
                          <p style={{ color: '#dc2626', fontSize: '0.82rem' }}>No available assets of this type. Add assets in Asset Register first.</p>
                        ) : (
                          <>
                            <Select
                              placeholder="Search and select asset..."
                              className="mb-3"
                              options={availableAssets.map(a => ({
                                value: a.id,
                                label: `${a.asset_tag} - ${a.brand?.name || ''} ${a.model_name || ''} ${a.serial_number ? '(S/N: ' + a.serial_number + ')' : ''} [${a.condition}]`
                              }))}
                              value={selectedAssetItemId ? availableAssets.filter(a => a.id == selectedAssetItemId).map(a => ({
                                value: a.id,
                                label: `${a.asset_tag} - ${a.brand?.name || ''} ${a.model_name || ''}`
                              }))[0] : null}
                              onChange={opt => setSelectedAssetItemId(opt ? opt.value : '')}
                              isClearable
                            />

                            {selectedAssetItemId && (() => {
                              const sel = availableAssets.find(a => a.id == selectedAssetItemId);
                              if (!sel) return null;
                              return (
                                <table className="table table-sm table-bordered mb-3" style={{ fontSize: '0.8rem' }}>
                                  <tbody>
                                    <tr><td style={{ fontWeight: 600, width: '35%' }}>Asset Tag</td><td>{sel.asset_tag}</td></tr>
                                    <tr><td style={{ fontWeight: 600 }}>Brand</td><td>{sel.brand?.name || '-'}</td></tr>
                                    <tr><td style={{ fontWeight: 600 }}>Model</td><td>{sel.model_name || '-'}</td></tr>
                                    <tr><td style={{ fontWeight: 600 }}>Serial</td><td>{sel.serial_number || '-'}</td></tr>
                                    <tr><td style={{ fontWeight: 600 }}>Condition</td><td>{sel.condition}</td></tr>
                                    <tr><td style={{ fontWeight: 600 }}>Allocate To</td><td>{activeTicket.createdByData ? activeTicket.createdByData.first_name + ' ' + activeTicket.createdByData.last_name : '-'}</td></tr>
                                  </tbody>
                                </table>
                              );
                            })()}

                            <button className="btn btn-success" onClick={handleAllocateAsset} disabled={allocating || !selectedAssetItemId} style={{ fontSize: '0.82rem' }}>
                              {allocating ? 'Allocating...' : 'Allocate Asset'}
                            </button>
                          </>
                        )}
                      </div>
                    </>
                  ) : activeTicket.status === '3' ? (
                    <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 8, padding: '16px', fontSize: '0.85rem' }}>
                      <strong style={{ color: '#dc2626' }}>Rejected</strong>
                      {activeTicket.head_rejection_reason && (
                        <div style={{ marginTop: 8 }}>Reason: {activeTicket.head_rejection_reason}</div>
                      )}
                    </div>
                  ) : activeTicket.status === '2' && activeTicket.category === 'hardware_request' ? (
                    <div style={{ background: '#ecfdf5', border: '1px solid #6ee7b7', borderRadius: 8, padding: '16px', fontSize: '0.85rem' }}>
                      <strong style={{ color: '#059669' }}>Asset Allocated</strong> - This request has been fulfilled.
                      {activeTicket.asset_item_id && (
                        <div style={{ marginTop: 8, color: '#64748b', fontSize: '0.78rem' }}>
                          Asset Item ID: {activeTicket.asset_item_id}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ color: '#64748b', fontSize: '0.82rem' }}>Status: {getStatusStyle(activeTicket.status).label}</div>
                  )}
                </div>
                ) : centerTab === 'history' ? (
                <div className="helpdesk-chat-body" style={{ padding: '16px' }}>
                  <h6 style={{ fontSize: '0.85rem', fontWeight: 700, marginBottom: 12 }}>
                    {activeTicket.createdByData ? activeTicket.createdByData.first_name + ' ' + activeTicket.createdByData.last_name : ''} - Asset History
                  </h6>
                  {empAssetHistory.length === 0 ? (
                    <p style={{ color: '#94a3b8', fontSize: '0.82rem' }}>No previous asset requests found.</p>
                  ) : (
                    <table className="table table-sm table-bordered" style={{ fontSize: '0.8rem' }}>
                      <thead style={{ background: '#f0f5ff' }}>
                        <tr><th>#</th><th>Asset Tag</th><th>Asset Type</th><th>Brand</th><th>Status</th><th>Date</th></tr>
                      </thead>
                      <tbody>
                        {empAssetHistory.map((a, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td style={{ fontWeight: a.tag !== '-' ? 700 : 400, color: a.tag !== '-' ? '#1167e8' : '#94a3b8' }}>{a.tag}</td>
                            <td>{a.name}</td>
                            <td>{a.brand}</td>
                            <td><span style={{ color: a.statusColor, fontWeight: 600, fontSize: '0.72rem' }}>{a.status}</span></td>
                            <td>{a.date ? moment(a.date).format('DD MMM YYYY') : '-'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
                ) : (
                <div className="helpdesk-chat-body">
                  {/* Ticket description as first message */}
                  {(() => {
                    const iAmCreator = String(activeTicket.createdByData?.id) === String(user_id);
                    return (
                      <div className={`chat-message ${iAmCreator ? 'own' : 'other'}`}>
                        <div className="chat-bubble">
                          {activeTicket.description ? Parser(activeTicket.description) : ''}
                        </div>
                        <div className="chat-meta">
                          <span className="chat-author">
                            {iAmCreator ? 'You' : (activeTicket.createdByData ? activeTicket.createdByData.first_name + ' ' + activeTicket.createdByData.last_name : '')}
                          </span> · {moment(activeTicket.created_at).format('DD-MM-YYYY, h:mm a')}
                        </div>
                      </div>
                    );
                  })()}

                  {commentsLoading ? <div className="text-center py-3"><DivSpinner size="sm" color="primary" /></div> :
                    comments.length > 0 && comments.map((c) => {
                      const isMe = String(c.comment_added_by) === String(user_id);
                      const isSystem = c.comment && (c.comment.includes('changed the status to') || c.comment.includes('approved this request') || c.comment.includes('rejected this request') || c.comment.includes('allocated asset'));
                      if (isSystem) {
                        return <div className="chat-system" key={c.id}><span>{c.comment}</span></div>;
                      }
                      return (
                        <div key={c.id} className={`chat-message ${isMe ? 'own' : 'other'}`}>
                          <div className="chat-bubble">{c.comment}</div>
                          <div className="chat-meta">
                            <span className="chat-author">{isMe ? 'You' : (c.user ? c.user.first_name + ' ' + c.user.last_name : 'Unknown')}</span>
                            {' · '}{moment(c.created_at).format('DD-MM-YYYY, h:mm a')}
                          </div>
                        </div>
                      );
                    })
                  }
                </div>
                )}

                <div className="helpdesk-chat-input">
                  <textarea
                    rows="1"
                    placeholder="Type your message..."
                    value={newComment}
                    onChange={(e) => setNewComment(e.target.value)}
                    onKeyPress={handleKeyPress}
                  />
                  <button className="send-btn" onClick={handleSendComment} disabled={!newComment.trim()}>
                    <FiSend size={16} />
                  </button>
                </div>
              </>
            ) : (
              <div className="helpdesk-chat-empty">Select a request to view conversation</div>
            )}
          </div>

          {/* RIGHT — Request Details + Status Update */}
          <div className="helpdesk-details">
            {activeTicket ? (
              <>
                <div className="helpdesk-details-header">
                  <h6>Request Details</h6>
                </div>
                <div className="helpdesk-details-body">
                  <div className="helpdesk-detail-group">
                    <div className="helpdesk-detail-label">Assignee</div>
                    <div className="helpdesk-detail-value">
                      <div className="assignee-row">
                        <div className="assignee-avatar">
                          {activeTicket.createdForData ? activeTicket.createdForData.first_name?.charAt(0) + activeTicket.createdForData.last_name?.charAt(0) : '?'}
                        </div>
                        <div>
                          <div style={{ fontWeight: 600, fontSize: "0.82rem" }}>
                            {activeTicket.createdForData ? activeTicket.createdForData.first_name + ' ' + activeTicket.createdForData.last_name : '-'}
                          </div>
                          <div style={{ fontSize: "0.72rem", color: "#64748b" }}>
                            {activeTicket.createdForData?.email || ''}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="helpdesk-detail-group">
                    <div className="helpdesk-detail-label">Category</div>
                    <div className="helpdesk-detail-value">
                      <span style={{ background: activeTicket.category === 'hardware_request' ? '#dbeafe' : activeTicket.category === 'software_request' ? '#f3e8ff' : activeTicket.category === 'it_support' ? '#ffedd5' : activeTicket.category === 'access_request' ? '#dcfce7' : '#f1f5f9', color: activeTicket.category === 'hardware_request' ? '#1e40af' : activeTicket.category === 'software_request' ? '#7c3aed' : activeTicket.category === 'it_support' ? '#c2410c' : activeTicket.category === 'access_request' ? '#166534' : '#475569', padding: '2px 10px', borderRadius: 12, fontSize: '0.72rem', fontWeight: 600 }}>
                        {activeTicket.category === 'hardware_request' ? 'Hardware Request' : activeTicket.category === 'software_request' ? 'Software Request' : activeTicket.category === 'it_support' ? 'IT Support' : activeTicket.category === 'access_request' ? 'Access Request' : 'General'}
                      </span>
                    </div>
                  </div>

                  <div className="helpdesk-detail-group">
                    <div className="helpdesk-detail-label">Set Status {updatingStatus && <span style={{ fontSize: '0.7rem', color: '#1167e8' }}>Updating...</span>}</div>
                    <select
                      value={activeTicket.status}
                      onChange={(e) => handleStatusChange(e.target.value)}
                      disabled={updatingStatus}
                    >
                      <option value="0">Open</option>
                      <option value="7">Accepted</option>
                      <option value="8">Pending Approval</option>
                      <option value="5">Approved</option>
                      <option value="1">In Progress</option>
                      <option value="2">Allocated</option>
                      <option value="9">Resolved</option>
                      <option value="3">Rejected</option>
                      <option value="4">Closed</option>
                      <option value="6">Returned</option>
                    </select>
                  </div>

                  <div className="helpdesk-detail-group">
                    <div className="helpdesk-detail-label">Priority</div>
                    <PriorityBadge priority={activeTicket.priority} />
                  </div>

                  <div className="helpdesk-detail-group">
                    <div className="helpdesk-detail-label">Subject</div>
                    <div className="helpdesk-detail-value">{activeTicket.title}</div>
                  </div>

                  {activeTicket.category === 'hardware_request' && activeTicket.asset_type_id && (
                    <div className="helpdesk-detail-group">
                      <div className="helpdesk-detail-label">Asset Type</div>
                      <div className="helpdesk-detail-value">{activeTicket.assetType?.name || 'ID: ' + activeTicket.asset_type_id}</div>
                    </div>
                  )}

                  {activeTicket.category === 'hardware_request' && activeTicket.quantity && (
                    <div className="helpdesk-detail-group">
                      <div className="helpdesk-detail-label">Quantity</div>
                      <div className="helpdesk-detail-value">{activeTicket.quantity}</div>
                    </div>
                  )}

                  {activeTicket.category === 'hardware_request' && activeTicket.justification && (
                    <div className="helpdesk-detail-group">
                      <div className="helpdesk-detail-label">Justification</div>
                      <div className="helpdesk-detail-value">{activeTicket.justification}</div>
                    </div>
                  )}

                  <div className="helpdesk-detail-group">
                    <div className="helpdesk-detail-label">Created By</div>
                    <div className="helpdesk-detail-value">
                      {activeTicket.createdByData ? activeTicket.createdByData.first_name + ' ' + activeTicket.createdByData.last_name : '-'}
                    </div>
                  </div>

                  <div className="helpdesk-detail-group">
                    <div className="helpdesk-detail-label">Date</div>
                    <div className="helpdesk-detail-value">{moment(activeTicket.created_at).format('DD MMM YYYY, h:mm a')}</div>
                  </div>

                  {activeTicket.e_support_cc_mails && activeTicket.e_support_cc_mails.length > 0 && (
                    <div className="helpdesk-detail-group">
                      <div className="helpdesk-detail-label">CC</div>
                      <ul className="helpdesk-cc-list">
                        {activeTicket.e_support_cc_mails.map((cc, i) => (
                          <li key={i}>{cc.user ? cc.user.first_name + ' ' + cc.user.last_name : cc.cc_user_id}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                </div>
              </>
            ) : (
              <div className="helpdesk-details-header">
                <h6>Request Details</h6>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default ManageTickets;
